/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
 *
 * https://github.com/zalando-lounge/modules/blob/master/packages/abtesting/README.md#cli
 */

import { AssignmentType, createConfig } from '@pegasus/abtesting';

export const { apiPrefix, pendingAssignments, timeout } = createConfig({
    apiPrefix: '/mylounge-api',
    pendingAssignments: [
        {
            // GBS - Reduce Confusion Desktop Web
            alias: 'ccf-reduce-confusion-desktop-web',
            id: 'a6a4bd5c-14f9-4094-ba7a-78f710f65456',
            defaultVariant: 'control_ccf_entry_reduce_confusion_desktop',
            variants: [
                'control_ccf_entry_reduce_confusion_desktop',
                'variant_ccf_entry_reduce_confusion_desktop',
            ],
            type: AssignmentType.SERVER,
            forced: 'variant_ccf_entry_reduce_confusion_desktop',
        },
        {
            // Search at Lounge
            alias: 'lounge_enable_search_feature',
            id: '27503c2c-c293-4a40-9d77-e3895697b1c6',
            defaultVariant: 'control_search_off',
            variants: [
                'control_search_off',
                'variant_search_on',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Discover - SAC New UI
            alias: 'sac-new-ui',
            id: '0feecbbd-2ed5-4694-9c2d-23fe0b8e314b',
            defaultVariant: 'control_sac',
            variants: [
                'control_sac',
                'variant_sac_new',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Convert - Product preview in cart
            alias: 'convert-product-preview-in-cart',
            id: 'cb6b5ef5-78ac-42e2-9473-9b98cd85aac6',
            defaultVariant: 'control_no_product_preview',
            variants: [
                'control_no_product_preview',
                'variant_cart_product_preview',
            ],
            type: AssignmentType.PRE_ASSIGNMENT,
        },
        {
            // Grow - Loyalty Birthday Voucher and Modal
            alias: 'birthday-voucher-experiment',
            id: '5614e7a0-45ab-4edd-9ff2-5a978013c43e',
            defaultVariant: 'birthday-voucher-control',
            variants: [
                'birthday-voucher-control',
                'birthday-voucher-treatment',
            ],
            type: AssignmentType.PRE_ASSIGNMENT,
        },
        {
            // Convert - Keep article in cart M2 - Cart Status
            alias: 'convert-kaic-cart-status',
            id: 'a555f68e-eec2-4d34-850b-4bba5eb8ee5f',
            defaultVariant: 'control_cart_status_generic',
            variants: [
                'control_cart_status_generic',
                'variant_cart_status_explained',
            ],
            type: AssignmentType.PRE_ASSIGNMENT,
        },
        {
            // Engage - Leaving Soon
            alias: 'engage_leaving_soon',
            id: '2dd88dd9-6329-4742-ab85-9d5758c58e5b',
            defaultVariant: 'control_disable_leaving_soon',
            variants: [
                'control_disable_leaving_soon',
                'variant_leaving_soon_component',
                'variant_leaving_soon_label',
            ],
            type: AssignmentType.PRE_ASSIGNMENT,
        },
    ],
    timeout: 200,
});
